import { Component, Host, h, State, Listen, Watch } from '@stencil/core';
import store from '../../../../global/store';
import { tracker } from '../../../../global/tracker';
import { BankBranch } from '../../../../../types/global'; // eslint-disable-line import/extensions
import { LocalStorageService } from '../../../../services/local-storage-service';

@Component({
  tag: 'ui-bank-search-map-overlay',
  styleUrl: 'ui-bank-search-map-overlay.scss',
})
export class UiBankSearchMapOverlay {
  @State() isSliderViewActive = true;

  @Listen('sd-change')
  handleRadioButtonClick(event: Event) {
    this.isSliderViewActive =
      (event.target as HTMLSelectElement).value === 'map';
  }

  @Watch('isSliderViewActive')
  handleSliderViewActiveChange() {
    this.trackActiveView();
  }

  componentWillLoad() {
    this.setFilterLabels();
  }

  private setFilterLabels(): void {
    store.state.availableFilters = store.state.availableFilters.map(
      (filter, index) => {
        if (index === 0) {
          return {
            ...filter,
            label: (window as any).ui.services?.i18n?.translate('bankSearch')
              .noFilter,
          };
        }
        return {
          ...filter,
          label: (window as any).ui.services?.i18n?.translate('bankSearch')[
            `${filter.value}Filter`
          ],
        };
      }
    );
  }

  trackActiveView() {
    if (this.isSliderViewActive) {
      tracker.trackMobileListView();
    } else {
      tracker.trackMobileMapView();
    }
  }

  // eslint-disable-next-line consistent-return
  handleFilterClick = (filter: BankBranch, e): void => {
    // if this is the default filter and is already selected, prevent deselecting it on click
    if (filter.default && filter.value === store.state.activeFilterValue) {
      return e.preventDefault();
    }

    // Currently adding a setTimeout for the target.value
    // to reflect it's true value from it's child component.
    //  TODO: come up with a better solution then setTimeout.
    setTimeout(() => {
      const filterDefault = store.state.availableFilters.find(
        (branch) => branch.default
      ).value;
      const filterCurrentBranch = filter.value;
      const isCurrentBranchSelected = e.target.selected;

      store.state.activeFilterValue = !isCurrentBranchSelected
        ? filterCurrentBranch
        : filterDefault;

      LocalStorageService.saveSearchValues();
    }, 0);
  };

  renderTagGroupContainer() {
    return (
      <sd-scrollable orientation="horizontal" buttons="true">
        {store.state.availableFilters.map((filter, index) => (
          <sd-tag
            key={index}
            selected={store.state.activeFilterValue === filter.value}
            onClick={(e) => this.handleFilterClick(filter, e)}
            removable={
              index !== 0 && store.state.activeFilterValue === filter.value
            }
          >
            {filter.label}
          </sd-tag>
        ))}
      </sd-scrollable>
    );
  }

  renderBankList() {
    return (
      <div class="map-overlay__list">
        <sd-scrollable orientation="vertical" shadows="true" scrollbars="true">
          <ui-bank-search-list mode="regular"></ui-bank-search-list>
        </sd-scrollable>
        {!store.state.resultsVisible?.length && ( // Todo currently no sd component for this
          <ui-alert class="map-overlay__alert" variant="warning">
            {(window as any).ui.services?.i18n?.translate('bankSearch')
              .noResult ||
              'Wir konnten zu Ihrer Auswahl keine passenden Bankfilialen finden. Bitte verwenden Sie einen anderen Filter.'}
          </ui-alert>
        )}
      </div>
    );
  }

  renderMobileToggleButton() {
    return (
      <div
        class={{
          'mobile-toggle': true,
          'mobile-toggle--condensed':
            store.state.isSliderCondensed && this.isSliderViewActive,
          'mobile-toggle--list': !this.isSliderViewActive,
        }}
      >
        <sd-radio-group value="map">
          <sd-radio-button value="map">
            <sd-icon
              aria-hidden="false"
              aria-label={
                (window as any).ui.services?.i18n?.translate('bankSearch')
                  .mapView ?? 'Kartenansicht'
              }
              slot="icon"
              library={(window as any).ui.cmsState?.iconLibrary}
              name="union-investment/system/position"
            ></sd-icon>
            <span slot="icon" class="sr-only">
              Kartenansicht
            </span>
          </sd-radio-button>
          <sd-radio-button label="List view" value="list">
            <sd-icon
              aria-hidden="false"
              aria-label={
                (window as any).ui.services?.i18n?.translate('bankSearch')
                  .listView ?? 'Listenansicht'
              }
              slot="icon"
              library={(window as any).ui.cmsState?.iconLibrary}
              name="union-investment/system/list"
            ></sd-icon>
            <span slot="icon" class="sr-only">
              Listenansicht
            </span>
          </sd-radio-button>
        </sd-radio-group>
      </div>
    );
  }

  render() {
    return (
      <Host>
        {/* --- DESKTOP VIEW --- */}
        <div class="map-overlay map-overlay--desktop">
          <div class="map-overlay__filter">
            <ui-bank-search-autocomplete></ui-bank-search-autocomplete>
            {this.renderTagGroupContainer()}
          </div>
          {this.renderBankList()}
        </div>

        {/* --- MOBILE VIEW --- */}
        <div class="map-overlay map-overlay--mobile">
          <div class="map-overlay__filter">
            <ui-bank-search-autocomplete></ui-bank-search-autocomplete>
            {this.renderTagGroupContainer()}
          </div>
          {this.isSliderViewActive ? (
            <ui-bank-search-mobile-slider class="mobile-tiles"></ui-bank-search-mobile-slider>
          ) : (
            this.renderBankList()
          )}
          {this.renderMobileToggleButton()}
        </div>
      </Host>
    );
  }
}
